import React from 'react'
import ReactHtmlParser from 'react-html-parser';
import { checkVariablesListForValue, getObject, priceStandardView, translate } from '../../utils/useful';
import moment from 'jalali-moment';
import CalendarInput from '../inputs/CalendarInput';
import AvailabilityTimeInput from '../inputs/AvailabilityTimeInput';
import SelectAvailableTimeInput from '../inputs/SelectAvailableTimeInput';
import DateInput from '../inputs/DateInput';
import MonthlyCalendarInput from '../inputs/MonthlyCalendarInput';
import Responsive from '../Responsive';
import AddToCardButton from '../tableComponents/AddToCardButton';
import HttpServices from '../../utils/Http.services';
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as actions from '../../stores/actionsList';


class AvailableTimesWidget extends React.Component {

    state = {
        data: {},
        times: []
    }


    componentDidMount() {
        this.init()
    }

    componentDidUpdate(prevProps) {

        // console.log(this.props.params)
        if (this.props.data?.content != this.state.rawData || this.props.params != prevProps.params) {
            this.init()
        }

    }


    init() {



        this.setState({ rawData: this.props.data?.content })

        // console.log('this.props.data', this.props.data)
        // console.log("this.props.header",this.props.header)
        // console.log("this.props.params",this.props.params)

        // console.log(this.props.fullData)
        // console.log(this.props.headers)

        // console.log(this.props.data?.content)
        // console.log('this.props.data?.contentl',this.props.data?.content)
        // let data = this.props.data?.service

        let baseService = this.props.data?.service?.replace('{{', '').replace("}}", '')
        let service = checkVariablesListForValue(this.props.params, baseService)?.data ?? null


        let baseProvider = this.props.data?.provider?.replace('{{', '').replace("}}", '')
        let provider = checkVariablesListForValue(this.props.params, baseProvider)?.data ?? null

        this.setState({ service, provider }, () => {

            if (!this.state.date) {

                this.setData('date', new Date(), () => {
                    this.fetchData()
                })

            }

        })

    }


    fetchData = () => {


        if (this.state.service && this.state.data?.date) {
            this.setState({ isLoadingTimes: true })

            let body = {
                service: this.state.service,
                provider: this.state.provider,
                date: this.state.data?.date

            }

            console.log("body", body)

            HttpServices.request('getAvailableTimes', body, (fetchResult, fetchError) => {

                console.log(fetchResult, fetchError)
                this.setState({ isLoadingTimes: false })


                if (fetchError) {
                    this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.loadDataFailed', description: fetchError.message })
                    return
                }

                this.setState({ times: fetchResult?.info ?? [] })
            })
        }


    }

    // changeInputValue(target) {
    //     let value = (target.validity.valid) ? target.value : null
    //     if (value !== null) {
    //         this.props.changeValue(this.props.header.key, value)
    //     }
    // }



    changeValue = (value) => {
        // console.log("changeValue")
        // console.log(value)
        this.props.changeValue(this.props.header.key, value, this.props.extra)
    }



    setData = (key, value, cb) => {
        // this.changeValue(value)
        let data = this.state.data ?? {}
        data[key] = value
        this.setState({ data }, () => {
            if (cb) {
                cb()
            }
        })
    }


    // selectTime = (key, value) => {

    //     this.setState({ selectedTime: value })

    // }





    render() {

        // if (this.state.data || this.props.editMode) {
        return (

            <div className='w-100'>

                <div className="w-100 h-100 d-flex flex-wrap " >

                    <Responsive width={this.props.width} media={{ xs: '12', 340: `240px`, 700: `340px`, lg: `340px`, xl: `340px` }}>
                        <div className='w-100 '>
                            <MonthlyCalendarInput colors={this.props.colors} data={this.state.data?.date} header={{ key: 'date', information: { required: true } }} changeValue={this.setData} />
                        </div>
                    </Responsive>
                    <Responsive width={this.props.width} media={{ xs: '12', 340: `${(this.props.width - 242)}px`, 700: `${(this.props.width - 342)}px`, lg: `${(this.props.width - 342)}px`, xl: `${(this.props.width - 342)}px` }}>
                        <div className={'w-100 ' + (this.props.width > 340 ? 'py-2 pld-10' : 'py-2')} >
                            <SelectAvailableTimeInput fullData={this.state.data} colors={this.props.colors} data={this.state.data?.time} header={{ key: 'time', information: { items: this.state.times } }} width={this.props.width} changeValue={this.setData} editMode={this.props.editMode} />

                            <div className='mt-4'>
                                <AddToCardButton colors={this.props.colors} product={this.state.product} variables={this.state.activeVariants} applet={this.props.applet?._id ?? this.props.variables.appletId} additionals={this.state.activeAdditionals} variants={this.state.activeVariants} changePage={this.props.changePage} label={translate("Book now")} />
                            </div>
                        </div>
                    </Responsive >


                </div>
            </div >
        )
        // } else {
        //     return (
        //         <></>
        //     )
        // }
    }
}


const mapStateToProps = state => ({ settings: state.settings, })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps,
    null,
    { forwardRef: true }
)(AvailableTimesWidget);